import Vue from 'vue'

/**
 * @author jorge nuñez lópez <>
 *
 * Get all responsibles from a specific warehouse
 * @return {object}
 */

const transformer = (data) => ({
  id: data.id,
  receiveName: data.user.receive_name
})

export default (warehouseId) => {

  return Vue.$http.get(`purchase/warehouse/${warehouseId}/available_responsibles/`)
    .then(response => {
      const responsibles = response.data.map(d => transformer(d))
      return responsibles
    })
    .catch((error) => {
      const response = error.response

      if (response && response.status !== 404) {
        throw error
      }
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchResponsibleUsers.js